<template>
  <div class="user-tab">
    <div class="user-tab__content">
      <div class="user-tab__fields-row"
           v-for="row in fieldsConfig"
           :key="row.property">
        <div class="user-tab__fields-row_title">
          {{ row.label }}
        </div>
        <template v-if="row.isSelectable">
          <base-select
                   class="user-tab__fields-row_field_select"
                   alignLeft
                   shiftLabelRight
                   :options="row.options"
                   :disabled="disableUsage"
                   :selectStyle="{height: '60px!important'}"
                   v-model="modelValues[row.property]"/>
        </template>
        <template v-else>
          <input v-model="modelValues[row.property]"
                 type="text"
                 :class="['user-tab__fields-row_field_input', {
                   'user-tab__fields-row_field_input_err': errorFields.includes(row.property),
                   'user-tab__fields-row_field_input_disabled': disableUsage
                 }]">
        </template>
      </div>
    </div>
    <div class="user-tab__footer">
      <template v-if="!isAddNew">
        <div class="user-tab__footer_title">Account Confirmed:</div>
        <div class="user-tab__footer_timestamp">{{ userData.confirmed_at }}</div>
      </template>
      <button :class="['user-tab__footer_button', { 'user-tab__footer_button_disabled': disableUsage }]"
              @click.prevent="saveUserData">{{ buttonText }}</button>
    </div>
  </div>
</template>

<script>
import EmailValidator from 'email-validator'
import { mapState, mapActions } from 'vuex'

const DEFAULT_FIELDS = [
  {
    label: 'Is Active',
    property: 'is_active',
    isSelectable: true,
    options: [
      {
        value: 1,
        label: 'Yes'
      },
      {
        value: 0,
        label: 'No'
      }
    ]
  },
  {
    label: 'First Name',
    property: 'first_name'
  },
  {
    label: 'Last Name',
    property: 'last_name'
  },
  {
    label: 'Email',
    property: 'email'
  }
]

export default {
  name: 'UserTab',
  data () {
    return {
      disableUsage: false,
      errorFields: [],
      sortConfig: [],
      fieldsConfig: [...DEFAULT_FIELDS],
      modelValues: {
        email: '',
        last_name: '',
        first_name: '',
        is_active: 1
      }
    }
  },
  computed: {
    ...mapState('userManager', ['userData']),
    userId () {
      return this.$route.params.id
    },
    isAddNew () {
      return this.$route.params.id === 'add-new-user'
    },
    buttonText () {
      return this.isAddNew ? 'Next' : 'Save'
    }
  },
  watch: {
    userData: {
      handler (obj) {
        Object.assign(this.modelValues, obj)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...mapActions('userManager', ['updateUserData', 'changeIsRecentlyAdded']),
    async saveUserData () {
      const errorFields = []

      const { email, last_name, first_name, is_active } = this.modelValues
      if (!EmailValidator.validate(email)) {
        errorFields.push('email')
      }
      if (!last_name || !last_name.length) {
        errorFields.push('last_name')
      }
      if (!first_name || !first_name.length) {
        errorFields.push('first_name')
      }
      if (!this.fieldsConfig[0].options.some(i => i.value === is_active)) {
        errorFields.push('is_active')
      }

      this.errorFields = errorFields
      if (errorFields.length) {
        return
      }

      this.disableUsage = true

      const { isUpdated = false, id = null } = await this.updateUserData({
        userId: this.userId,
        email,
        last_name,
        first_name,
        is_active,
        successMessage: this.isAddNew ? 'User created successfully' : 'User updated successfully'
      })

      this.disableUsage = false

      if (this.isAddNew && isUpdated) {
        this.changeIsRecentlyAdded(true)
        this.$router.push({ path: `/system/user_manager/${id}/agency-roles` })
      }

      if (isUpdated) {
        this.$emit('updateData')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .user-tab {
    padding: 0 24px 24px;

    &__fields-row {
      padding-top: 24px;
      max-width: 50%;

      &_field {
        &_input {
          padding-left: 10px;
          border: 1px solid $rfx-light-steel;
          height: 60px;

          &_err {
            border: 1px solid $rfx-light-red;
            color: $rfx-light-red;
          }

          &_disabled {
            pointer-events: none;
          }
        }

        &_select {
        }
      }

      &_title {
        font-weight: bold;
        line-height: 20px;
      }
    }

    &__fields-row,
    &__content {
      display: flex;
      flex-direction: column;
    }

    &__footer {
      max-width: 50%;
      margin-top: 24px;
      display: flex;
      flex-direction: column;

      &_title {
        color: $rfx-light-march;
        font-size: 14px;
      }

      &_timestamp {
        color: $rfx-dark-march;
        font-size: 14px;
        font-weight: bold;
        margin-top: 6px;
      }

      &_button {
        margin-top: 24px;
        height: 40px;
        width: 100px;
        background-color: $rfx-medium-march;
        text-align: center;
        color: white;
        border: none;
        margin-left: auto;
        border-radius: $rfx-default-border-radius;

        &_disabled {
          pointer-events: none;
          opacity: .5;
        }
      }
    }
  }
</style>
